import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { TraineeList } from './TraineeList';
import { TraineeDatagrid } from './TraineeDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Trainee } from './Trainee';

export * from './Trainee';
export * from './TraineeCreate';
export * from './TraineeDatagrid';
export * from './TraineeEdit';
export * from './TraineeList';
export * from './TraineeShow';

const TraineesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'fullName', header: 'שם מלא' },
	{ key: 'user.phone.phone', header: 'טלפון' },
	{ key: 'profileImageUrl', header: 'תמונת פרופיל' },
	{ key: 'menuPdfUrl', header: 'תפריט' },
	{ key: 'birthDate', header: 'תאריך לידה' },
	{ key: 'email', header: 'אימייל' },
	{ key: 'height', header: 'גובה' },
	{ key: 'weight', header: 'משקל' },
	{ key: 'gender', header: 'מין' },
	{ key: 'trainingType', header: 'סוג אימון' },
	{ key: 'coach.fullName', header: 'מאמן' },
	{ key: 'approvedByCoach', header: 'אושר על ידי מאמן?' },
	{ key: 'address.addressStr', header: 'כתובת' },
	{ key: 'shouldReceiveMotivationNotifications', header: 'אמור לקבל התראה על מוטיבציה?' },
	{ key: 'shouldReceiveWeightingReminder', header: 'אמור לקבל התראה על שקילה?' },
	{ key: 'shouldReceiveSendingImageReminder', header: 'אמור לקבל התראה על צילום שקילה?' },
	{ key: 'shouldCoachReceivePersonalMessagesReminder', header: 'מאמן אמור לקבל התראה על הודעות פרטיות למתאמנים?' },
	{ key: 'shouldCoachReceiveTraineesProgressReminder', header: 'מאמן אמור לקבל התראה על התקדמות מתאמן?' },
	{ key: 'shouldCoachReceiveBirthdayNotifications', header: 'מאמן אמור לקבל התראה על ימי הולדת?' },
	{ key: 'shouldCoachReceiveNonUploadersReminder', header: 'מאמן אמור לקבל התראה על מתאמנים שלא נשקלו?' }
	// { key: 'note', header: 'הערה' }
];

export const TraineesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Trainee) => entity;

	const traineesFilter = [
		<TextInput source="fullName" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('מתאמנים', exportFields, exportDataMapper)}
				{...props}
				filters={traineesFilter}
				bulkActionButtons={<TraineesBulkActionButtons/>}
				title="TRAINEES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				filter={{ isCoach: false }}
				hasCreate={false}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <TraineeList/> : <TraineeDatagrid/>}
			</List>
		</Fragment>
	);
};
